import React, { useEffect } from 'react'
import { viewPdfReport } from '../../../service/StudyReportService';
import { useSearchParams } from 'react-router-dom';

const QRCodeScanReport = () => {

    const [searchParams] = useSearchParams();

  //  sanitization 
  const sanitizeParam = (value) => {
    if (!value) return "";

    // allow only alphanumeric + limited safe chars
    const safe = value.match(/^[a-zA-Z0-9_-]+$/);
    return safe ? value : "";
  };

  useEffect(() => {
    const segments = window.location.pathname.split("/").filter(Boolean);
    // let studyId = window.location.pathname.split("/").slice(-2)[0];
    // let fileTypeSelected = searchParams.get("fileTypeSelected");
    // let sourceFirmId =  window.location.pathname.substring(
    //   window.location.pathname.lastIndexOf("/") + 1
    //  );
    // sanitize extracted values
    const rawStudyId = segments[segments.length - 2] || "";
    const rawSourceFirmId = segments[segments.length - 1] || "";

    const studyId = sanitizeParam(rawStudyId);
    const sourceFirmId = sanitizeParam(rawSourceFirmId);
    
    const fileTypeSelected = sanitizeParam(
      searchParams.get("fileTypeSelected")
    );
    

        let payload = {
          studyId : studyId,
          sourceFirmId: sourceFirmId,
          fileTypeSelected: fileTypeSelected
        };
        console.log(payload);
        viewPdfReport(payload);
    },[])

  return (<></>)
}

export default QRCodeScanReport